/**
 * Gezichtsloze, organisch morphende baas-presence (§17): CSS radial-gradient +
 * blur + morphende border-radius, in de chakra-kleur. "Ominous presence", geen
 * plaatjes nodig. Reduced-motion bevriest de animatie.
 */
interface Props {
  kleur: string;
  accent: string;
  grootte?: number;
}

export function BaasBlob({ kleur, accent, grootte = 80 }: Props) {
  return (
    <div className="relative shrink-0" style={{ width: grootte, height: grootte }}>
      <div
        className="ca-blob absolute inset-0"
        style={{
          background: `radial-gradient(circle at 40% 35%, ${accent}, ${kleur} 58%, transparent 76%)`,
          filter: 'blur(2px)',
        }}
      />
      <div
        className="absolute inset-[22%] rounded-full"
        style={{ background: `radial-gradient(circle at 45% 40%, #000 0%, ${kleur}00 70%)`, opacity: 0.35 }}
      />
    </div>
  );
}
